import { useProductsQuery } from '../queries/productsQuery';

export const useServiceProducts = (serviceId: string) => {
    const serviceIds = serviceId ? [serviceId] : undefined;

    const serviceProducts = useProductsQuery({ serviceIds }, { enabled: !!serviceId });

    return serviceProducts.data?.products ?? [];
};
